import { InteractionRequiredAuthError } from '@azure/msal-browser';
import {
    Chart,
    ChartSeriesItem,
    ChartSeries,
    ChartSeriesLabels,
    ChartLegend
} from '@progress/kendo-react-charts';
import { useLocalization } from '@progress/kendo-react-intl';
import axios from 'axios';

import 'hammerjs';
import { useEffect, useRef, useState } from 'react';
import { AccessToken } from '../../config/AccessToken';
import { loadingPanel } from '../LoadingPanel';



export const DevicesBatteryStatus = (props: any) => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;

    const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');

    const [loading, setLoading] = useState(false);


    let labelStatusDevicesLoad = localizationService.toLanguageString('dashboard.widget.devices_status.device_charged', 'NOT_FOUND');
    let labelStatusDevicesUnload = localizationService.toLanguageString('dashboard.widget.devices_status.device_uncharged', 'NOT_FOUND');
    let labelStatusDevicesUnknown = localizationService.toLanguageString('dashboard.widget.devices_status.device_unknown', 'NOT_FOUND');

    const [totalDevices, setTotalDevices] = useState(0);
    const [counterLoaded, setCounterLoaded] = useState(0);
    const [counterUnloaded, setCounterUnloaded] = useState(0);
    const [devicesStatus, setDevicesStatus] = useState([
        { 'deviceName': labelStatusDevicesLoad, 'counterStatus': 0, 'colorField': "green" },
        { 'deviceName': labelStatusDevicesUnload, 'counterStatus': 0, 'colorField': "red" },
        { 'deviceName': labelStatusDevicesUnknown, 'counterStatus': 0, 'colorField': "black" }
    ]);
    const [error, setError] = useState('');

    const tileRef = useRef<HTMLDivElement>(null);

    const [rowSpan, setRowSpan] = useState<number>(0);
    const [colSpan, setColSpan] = useState<number>(0);

    const batteryPercentage:any = localStorage.getItem('batteryPercentage');

    useEffect(() => {
        labelStatusDevicesLoad = localizationService.toLanguageString('dashboard.widget.devices_status.device_charged', 'NOT_FOUND')
        labelStatusDevicesUnload = localizationService.toLanguageString('dashboard.widget.devices_status.device_uncharged', 'NOT_FOUND')
        labelStatusDevicesUnknown = localizationService.toLanguageString('dashboard.widget.devices_status.device_unknown', 'NOT_FOUND')
    }, [localizationService]);

    const [instance, accessTokenRequest] = AccessToken();

    const getDeviceList = async () => {

        setLoading(true);

        const commonOperations = (accessToken: any) => {
            const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
            axios.get(`${SERVER_URL}/device/list`, { headers })
                .then((res: any) => {
                    if(res.length == 0) return

                    const data = res?.data

                    let counterLoaded = 0
                    let counterUnloaded = 0
                    let counterUnknown = 0
                    let counterActiveDevice = 0
                    let devicesStatusList: any[] = [
                        { 'deviceName': labelStatusDevicesLoad, 'counterStatus': 0, 'colorField': "green" },
                        { 'deviceName': labelStatusDevicesUnload, 'counterStatus': 0, 'colorField': "red" },
                        { 'deviceName': labelStatusDevicesUnknown, 'counterStatus': 0, 'colorField': "black" },
                    ]

                    data.data.map((device: any) => {
                        if(device.isEnabled){
                            if(device.battery == null){
                                counterUnknown++
                            }
                            else if (device.battery <= batteryPercentage) {
                                counterUnloaded++
                            } else {
                                counterLoaded++
                            }
                            counterActiveDevice++
                        }
                    });
                    setTotalDevices(counterActiveDevice)
                    devicesStatusList[0].counterStatus = counterLoaded
                    devicesStatusList[1].counterStatus = counterUnloaded
                    devicesStatusList[2].counterStatus = counterUnknown
                    devicesStatusList[0].deviceName = localizationService.toLanguageString('dashboard.widget.devices_status.device_charged', 'NOT_FOUND');
                    devicesStatusList[1].deviceName = localizationService.toLanguageString('dashboard.widget.devices_status.device_uncharged', 'NOT_FOUND');
                    devicesStatusList[2].deviceName = localizationService.toLanguageString('dashboard.widget.devices_status.device_unknown', 'NOT_FOUND');
                    setDevicesStatus(devicesStatusList)
                    
                    setCounterUnloaded(counterUnloaded)
                    setCounterLoaded(counterLoaded)

                    setLoading(false);
                    
                }).catch((data) => {
                    setError(data?.message);
                    setLoading(false);
                });
        }

        if (localStorage.getItem('accessToken') != null) {
            let accessToken = localStorage.getItem('accessToken');
            commonOperations(accessToken);
        }
        else {
            await instance.initialize();
            await instance.setActiveAccount(accessTokenRequest.account);
            await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                // Acquire token silent success
                let accessToken = accessTokenResponse.accessToken;
                commonOperations(accessToken);
            })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    console.log(error);
                });
        }

    }

    useEffect(() => {
        getDeviceList()
    }, [])

    const donutCenterRenderer = () => (
        <span style={{ 'fontSize': '10px' }}>
            <h3>{counterUnloaded}/{totalDevices}</h3>
            {languageId === 'it-IT' ? 'Scarichi' : 'Not charged'}
            <br />
            (Batt.{'<'}{batteryPercentage}%)
        </span>
    );


    const labelContent = (props: any) => {
        if(props.dataItem.counterStatus > 0){
            if(languageId == 'it-IT'){
                if (props.category == 'Dispositivi carichi'){ 
                    return `Carichi \n(${props.dataItem.counterStatus})`
                }
                else if (props.category == 'Dispositivi scarichi') {
                    return `Scarichi \n(${props.dataItem.counterStatus})`
                }
                else {
                    return `Sconosciuti \n (${props.dataItem.counterStatus})`
                }             
            }else{
                if(props.dataItem.colorField == 'green'){
                    return `Charged \n(${props.dataItem.counterStatus})`
                }
                else  if (props.dataItem.colorField == 'red') {
                    return `Not charged \n(${props.dataItem.counterStatus})`
                }
                else {
                    return `Unknown \n(${props.dataItem.counterStatus})`
                }
            }
        }else{
            return ''
        }
    };


    let currRowSpan = props?.['rowSpan']
    let currColSpan = props?.['colSpan']
    // console.log('currRowSpan: ',currRowSpan, currColSpan);

    useEffect(() => {

        if (currRowSpan) {
            setRowSpan(currRowSpan)
        }
        if (currColSpan) {
            setColSpan(currColSpan)
        }

    }, [currRowSpan, currColSpan]);

    return (
        <div ref={tileRef} >
            {loading && loadingPanel}
            {
            totalDevices > 0 ?
                <Chart donutCenterRender={donutCenterRenderer} >
                    <ChartSeries >
                        <ChartSeriesItem
                            type="donut"
                            data={ devicesStatus }
                            categoryField={'deviceName'}
                            field={'counterStatus'}
                            colorField="colorField"
                            tooltip={{ visible: true }}
                        >
                            <ChartSeriesLabels
                                distance={5}
                                position="outsideEnd"
                                font="0.8cqw"
                                visible={true}
                                content={labelContent}
                            />
                        </ChartSeriesItem>
                    </ChartSeries>
                    <ChartLegend position="bottom" orientation="horizontal" />
                </Chart>
            :
            // Mostra un messaggio o un altro contenuto se non ci sono dati
            <div style={{ textAlign: 'center', padding: '20px', border: '1px dashed #ccc' }}>
                <p>{localizationService.toLanguageString('dashboard.widget.devices_status.no_value', 'NOT_FOUND')}</p>
            </div>
            }
        </div>
    )
}